import {defineStore} from 'pinia'
import reverse from "lodash/reverse";
import sortBy from "lodash/sortBy";
import {isAxiosError} from "axios";
import {AccountApi} from "~/gen/openapi/portalService";
import documentsApi from "~/api/documents.api";
import {useAccountId} from "~/composables/useAccountId";

interface State {
    errorMessage: string,
    isFetching: boolean,
    items: Array<any>,
}

export const useDocumentsStore = defineStore('documents', {
  state: (): State => ({
      errorMessage: '',
      isFetching: false,
      items: [],
	}),
	getters: {
        itemsSorted(state) {
            return reverse(sortBy(state.items, 'LastModifiedDate'))
        },
	},
	actions: {
        async fetch() {
            const accountId = useAccountId()
            if (!accountId.value) {
                return
                // throw new Error('Missing accountId')
            }

            this.isFetching = true
            const {$config, $axios} = useNuxtApp()

            const accountApi = new AccountApi(undefined, $config.public.apiBaseHost, $axios);
            try {
                this.items = (await accountApi.accountGetAccountDocuments(accountId.value))?.data as unknown as any[]
            } catch (e: any) {
                this.items = []
                if (isAxiosError(e) && e.response) {
                    this.errorMessage = `${e.response.status}: ${e.response.statusText}`
                } else {
                    this.errorMessage = e.toString()
                }

                throw e
            } finally {
                this.isFetching = false
            }
        },
        async delete(documentId: any, orderService: any) {
            const accountId = useAccountId()
            if (!documentId || !accountId.value) {
                return
            }

            const {$axios} = useNuxtApp()

            await documentsApi($axios).delete({ accountId: accountId.value, documentId })
            orderService.removeDocument(documentId)
        },
	}
})
